// Modèle de formulaire d'inspection et brouillons : même définition que le serveur (contrôle faisant foi),
// partagée par le package commun.

export * from '@carburanttrack/shared/inspections';

/** Préfixe des identifiants de photos conservées sur l'appareil, remplacés par l'identifiant du document à l'envoi. */
export const PREFIXE_PHOTO_LOCALE = 'local:';

export function estPhotoLocale(id: string): boolean {
  return id.startsWith(PREFIXE_PHOTO_LOCALE);
}
